import { Pipe, PipeTransform } from '@angular/core';
import { str2Date } from 'globals/helpers/helpers';

@Pipe({
    name: 'customDate',
    standalone: true
})
export class CustomDatePipe implements PipeTransform {
  transform(dateId: string): Date {
    return str2Date(dateId)
  }
}

